module.exports = __webpack_public_path__ + "img/wechat.1ed6855b.png";